import { Box, Button, TextField, Typography } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { useLocation, useNavigate } from 'react-router-dom';
import Loader from '../../../utility/Loader';
import api_service from "../../../network/api_callbacks";
import { GameCssStyles } from "../../../components/GameManagement/GameCssStyles";
import { updateStateObjectData } from "../../../utility/Common";
import { getSingleFileByNameFromAWSS3Bucket, uploadFileToAWSS3Bucket } from "../../../services/uploadFileOnAWS_S3_Bucket";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import dayjs from "dayjs";
import MultimediaDialog from "./MultimediaDialog";

const default_claims = [
    {
        "displayName": "Top Line",
        "type": "top_line",
        "points": 0
    },
    {
        "displayName": "Bottom Line",
        "type": "bottom_line",
        "points": 0
    },
    {
        "displayName": "Early Five",
        "type": "early_five",
        "points": 0
    },
    {
        "displayName": "Middle Line",
        "type": "middle_line",
        "points": 0
    },
    {
        "displayName": "Full House",
        "type": "full_house",
        "points": 0
    },
    {
        "displayName": "Four Corners",
        "type": "four_corners",
        "points": 0
    }
]

const RapHousiCreateGame = (props) => {

    const navigate = useNavigate();
    const location = useLocation();
    const pathname = location.pathname;
    const state = location.state;
    const [loader, setLoader] = useState(false);
    const [gameDetail, setGameDetail] = useState(null);
    const [videoDetails, setVideoDetails] = useState(null);
    const fileInputSmallRef = useRef(null);
    const fileInputFullRef = useRef(null);
    const [openMultimediaDialog, setOpenMultimediaDialog] = useState(false);

    useEffect(() => {
        if (gameDetail === null && videoDetails === null && location?.state?.gameDataFromList) {
            getTambolaGameDetail(location?.state?.gameDataFromList?._id);
        }
        else {
            setGameDetail({ claims: default_claims });
        }
        return () => {
            setGameDetail(null);
        }
    }, [state]);

    const handleBackToHousieGamesManagement = () => {
        const path = location?.pathname;
        const cleanedPath = path.substring(0, path.lastIndexOf("/"));
        navigate(`${cleanedPath}`, {
            state: { shouldRefresh: true }
        });
    };

    const getTambolaGameDetail = async () => {
        if (location?.state?.gameDataFromList) {
            setLoader(true);
            try {
                const response = await api_service.getTambolaGameDetail({ gameId: location.state?.gameDataFromList?._id });

                const gameDetail = response;
                const games = gameDetail?.games;
                const videoDetails = gameDetail?.videoDetails;

                console.log('📘 gameDetail :', gameDetail);
                console.log('📘 games :', games);
                console.log('📘 videoDetails :', videoDetails);

                setGameDetail(games || null);
                setVideoDetails(videoDetails || null);

                setLoader(false);
            } catch (error) {
                setLoader(false);
                console.error('❌ Failed to fetch getActiveStats:', error);
            }
        }
    }

    const deleteGame = async () => {
         setLoader(true);
            try {

                setLoader(false);
            } catch (error) {
                setLoader(false);
                console.error('❌ Failed to fetch deleteGame:', error);
            }
    }

    const createGame = async () => {
        if (gameDetail !== null && gameDetail?.tambolaVideoId !== null) {
            setLoader(true);
            try {
                const response = await api_service.createTambolaGames({ data : gameDetail });

                console.log('📘 response create :', response);

                handleBackToHousieGamesManagement();

                setLoader(false);
            } catch (error) {
                setLoader(false);
                console.error('❌ Failed to fetch createGame:', error);
            }
        }
    }

    const editGame = async () => {
        if (gameDetail !== null && gameDetail?._id !== null && gameDetail?.tambolaVideoId !== null) {
            setLoader(true);
            try {
                //const data = {...gameDetail,}
                const response = await api_service.editTambolaGames({ id: gameDetail?._id, data: gameDetail});

                console.log('📘 response edit :', response);

                handleBackToHousieGamesManagement();

                setLoader(false);
            } catch (error) {
                setLoader(false);
                console.error('❌ Failed to fetch editGame:', error);
            }
        }
    }

    const handleChange = (path, value) => {
        updateStateObjectData(gameDetail, setGameDetail, path, value);
    };

    const handleGameBannerChnageUploadImageBTClick = (ref) => {
        if (ref?.current) {
            ref.current.click();
        }
    };

    const handleGameBannerFileChange = async (event, field) => {
        const file = event.target.files[0];
        if (file) {
            const url = URL.createObjectURL(file);
            const mimeType = file.type;
            let type = "unknown";
            if (mimeType.startsWith("image/")) {
                type = "image";
            }

            console.log("File selected:", file, "URL:", url, "Type:", type);

            const result = await uploadFileToAWSS3Bucket("banners", file);
            console.log("Upload AWS result : ", result);

            const fileResult = await getSingleFileByNameFromAWSS3Bucket(
                "banners",
                result?.key?.split("/").pop()
            );
            console.log("Single File AWS fileResult : ", fileResult);

            handleChange(field, fileResult.url || fileResult); // store only for that field
        } else {
            console.error("No file selected");
            handleChange(field, "");
        }
    };

    return (
        <>
            <Box sx={{
                flex: 1,
                height: '100%',
                display: "flex",
                padding: 0,
                flexDirection: "column",
                gap: 0,
                marginBottom: 0,
                position: "relative",
                overflow: "auto"
            }}>

                <Box sx={{
                    flex: 1,
                    height: '100%',
                    display: "flex",
                    padding: 5,
                    flexDirection: "column",
                    gap: 0,
                    marginBottom: 0,
                    position: "relative",
                    overflow: "auto"
                }}>

                    <Box sx={{ display: "flex", justifyContent: "space-between", mb: 4 }}>
                        {gameDetail?._id && <Typography variant="h6" fontWeight={600} mb={0} alignSelf={"start"} justifySelf={'start'}>Game ID : {gameDetail?._id}</Typography>}
                    </Box>

                    <Box sx={GameCssStyles.containerStyleColumn_sx}>
                        <Typography variant="h6" fontWeight={600} mb={0} alignSelf={"start"} justifySelf={'start'}>About Game</Typography>
                        <Box display="flex" alignItems="stretch" gap={3} mt={0} width="100%">
                            <TextField
                                fullWidth
                                label="Title"
                                multiline={false}
                                rows={1}
                                value={gameDetail?.title || ''}
                                onChange={(e) => { handleChange("title", e.target.value) }}
                                sx={GameCssStyles.formSingleLineTextField_sx}
                            />
                            {/* <TextField
                                fullWidth
                                label="Sub Title"
                                multiline={false}
                                rows={1}
                                value={gameDetail?.subTitle}
                                onChange={(e) => handleChange("subTitle", e.target.value)}
                                sx={GameCssStyles.formSingleLineTextField_sx}
                            /> */}
                        </Box>

                        <Box background={"#f4f1f9"} display="flex" flex={1} flexDirection="row" gap={3} mt={3}>
                            <TextField
                                fullWidth
                                label="Game Banner Small"
                                multiline={false}
                                rows={1}
                                value={gameDetail?.banner?.small || ''}
                                onChange={(e) => handleChange("banner.small", e.target.value)}
                                sx={GameCssStyles.formSingleLineTextField_sx}
                            />
                            <>
                                <input
                                    type="file"
                                    accept="image/*"
                                    ref={fileInputSmallRef}
                                    style={{ display: "none" }}
                                    onChange={(e) => handleGameBannerFileChange(e, "banner.small")}
                                />
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    sx={{ height: "100%" }}
                                    onClick={() => handleGameBannerChnageUploadImageBTClick(fileInputSmallRef)}
                                >
                                    {gameDetail?.banner?.small ? "Change" : "Upload"}
                                </Button>
                            </>
                        </Box>

                        <Box background={"#f4f1f9"} display="flex" flex={1} flexDirection="row" gap={3} mt={3}>
                            <TextField
                                fullWidth
                                label="Game Banner Full Width"
                                multiline={false}
                                rows={1}
                                value={gameDetail?.banner?.fullWidth || ''}
                                onChange={(e) => handleChange("banner.fullWidth", e.target.value)}
                                sx={GameCssStyles.formSingleLineTextField_sx}
                            />
                            <>
                                <input
                                    type="file"
                                    accept="image/*"
                                    ref={fileInputFullRef}
                                    style={{ display: "none" }}
                                    onChange={(e) => handleGameBannerFileChange(e, "banner.fullWidth")}
                                />
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    sx={{ height: "100%" }}
                                    onClick={() => handleGameBannerChnageUploadImageBTClick(fileInputFullRef)}
                                >
                                    {gameDetail?.banner?.fullWidth ? "Change" : "Upload"}
                                </Button>
                            </>
                        </Box>

                        <Box background={"#f4f1f9"} display="flex" flex={1} flexDirection="row" gap={3} mt={3}>
                            <TimePicker
                                label="Trigger Time"
                                minDateTime={dayjs()}
                                //maxDateTime={dayjs().subtract(30, 'day')} 
                                value={gameDetail?.triggerTime ? dayjs(gameDetail?.triggerTime, "HH:mm") : null}
                                onChange={(v) => {
                                    const milliseconds = dayjs(v).format("HH:mm");
                                    console.log("Trigger Time At Changed : ", milliseconds);
                                    handleChange("triggerTime", milliseconds)
                                }}
                                slotProps={{ textField: { fullWidth: true } }}
                                sx={GameCssStyles.formSingleLineTextField_sx}
                            />

                            <TimePicker
                                label="Daily Go Live Time"
                                minDateTime={dayjs()}
                                //maxDateTime={dayjs().subtract(30, 'day')} 
                                value={gameDetail?.dailyGoLiveTime ? dayjs(gameDetail?.dailyGoLiveTime, "HH:mm") : null}
                                onChange={(v) => {
                                    const milliseconds = dayjs(v).format("HH:mm");
                                    console.log("Daily Go Live Time : ", milliseconds);
                                    handleChange("dailyGoLiveTime", milliseconds)
                                }}
                                slotProps={{ textField: { fullWidth: true } }}
                                sx={GameCssStyles.formSingleLineTextField_sx}
                            />

                        </Box>
                    </Box>

                    <Box sx={[{ ...GameCssStyles.containerStyleColumn_sx }, { mt: 4 }]}>

                        <Box background={"#f4f1f9"} display="flex" flex={1} flexDirection="row" gap={3} justifyContent={"space-between"} mt={0}>
                            <Typography variant="h6" fontWeight={600} mb={0} alignSelf={"start"} justifySelf={'start'}>Game Multimedia</Typography>
                            <Button
                                variant="contained"
                                color="secondary"
                                sx={{ height: "100%" }}
                                onClick={() => {
                                    setOpenMultimediaDialog(true);
                                }}
                            >
                                Add Multimedia
                            </Button>
                        </Box>

                        {/* Show video details */}
                        {videoDetails && (
                            <Box
                                sx={{
                                    mt: 2,
                                    display: "flex",
                                    flexDirection: "row",
                                    gap: 2,
                                    p: 2,
                                    border: "1px solid #ddd",
                                    borderRadius: 2,
                                    background: "white",
                                }}
                            >
                                {/* Thumbnail */}
                                <Box
                                    component="img"
                                    src={videoDetails?.image}
                                    alt={videoDetails?.title || "thumbnail"}
                                    sx={{
                                        width: 200,
                                        height: 120,
                                        objectFit: "cover",
                                        borderRadius: 2,
                                        border: "1px solid #ccc",
                                    }}
                                />

                                <Box
                                    sx={{
                                        flex: 1,
                                        display: "flex",
                                        flexDirection: "row",
                                        gap: 2,
                                        justifyContent: "space-between"
                                    }}
                                >
                                    {/* Info */}
                                    <Box display="flex" flexDirection="column" gap={1} justifyContent={"flex-start"} alignItems={"flex-start"}>
                                        <Typography variant="subtitle1" fontWeight={600}>
                                            {videoDetails?.title || "Untitled"}
                                        </Typography>
                                        <Typography variant="body2" color="text.secondary">
                                            Video ID: {videoDetails?._id}
                                        </Typography>
                                        <Typography variant="body2" color="text.secondary">
                                            Duration: {videoDetails?.duration} sec
                                        </Typography>
                                    </Box>

                                    {/* Timeline */}
                                    <Box display="flex" flexDirection="column" gap={1}>
                                        {Array.isArray(videoDetails?.timeLine) && (
                                            <Box mt={0}>
                                                <Typography variant="subtitle2" fontWeight={600}>
                                                    Timeline Markers:
                                                </Typography>
                                                {videoDetails?.timeLine?.length > 0 ? (
                                                    <ul style={{ margin: "4px 0", paddingLeft: "20px" }}>
                                                        {videoDetails?.timeLine?.map((marker, idx) => (
                                                            <li key={idx}>
                                                                <Typography variant="body2" textAlign={"start"}>
                                                                    {/* {idx + 1 || "N/A"} - {marker?.time || "N/A"}s */}
                                                                    {marker?.time || "N/A"}s - EE ID:{marker?.entityId} - MM ID:{marker?.multimediaId}
                                                                </Typography>
                                                            </li>
                                                        ))}
                                                    </ul>
                                                ) : (
                                                    <Typography variant="body2" color="text.secondary">
                                                        No timeline markers
                                                    </Typography>
                                                )}
                                            </Box>
                                        )}
                                    </Box>

                                </Box>

                            </Box>
                        )}
                    </Box>

                    <Box sx={[{ ...GameCssStyles.containerStyleColumn_sx }, { mt: 4 }]}>

                        <Typography variant="h6" fontWeight={600} mb={0} alignSelf={"start"} justifySelf={'start'}>Game Contest Rules</Typography>

                        <Box sx={GameCssStyles.containerStyleColumnWithoutBorder_sx}>
                            <TextField
                                fullWidth
                                label="Ticket Price (Rapcoin)"
                                type="number"
                                value={gameDetail?.ticketPrice?.rapCoin || 0}
                                onChange={(e) =>
                                    handleChange('ticketPrice.rapCoin', e.target.value)
                                }
                                sx={{ ...GameCssStyles.formSingleLineTextField_sx, width: '150px' }}
                            />

                            {/* Tambola Claim Rules */}
                            <Box
                                background={"#f4f1f9"}
                                display="flex"
                                flexWrap="wrap"
                                gap={3}
                                mt={3} >
                                {default_claims?.map((claim, index) => {
                                    // Prefer values from existing game claims if editing
                                    const existingClaim = gameDetail?.claims?.find(
                                        (c) => c?.type === claim?.type
                                    );

                                    const displayName = existingClaim?.displayName ?? claim?.displayName;
                                    const type = existingClaim?.type ?? claim?.type;
                                    const _id = existingClaim?._id ?? '';
                                    const value = existingClaim?.points ?? claim?.points;

                                    return (
                                        <TextField
                                            key={claim?.type}
                                            fullWidth
                                            label={`${claim?.displayName} (Points)`}
                                            type="number"
                                            value={value}
                                            onChange={(e) => {
                                                _id && handleChange(`claims.${index}._id`, `${_id}`)
                                                handleChange(`claims.${index}.displayName`, `${displayName}`)
                                                handleChange(`claims.${index}.type`, `${type}`)
                                                handleChange(`claims.${index}.points`, Number(e.target.value))
                                            }}
                                            sx={{
                                                ...GameCssStyles.formSingleLineTextField_sx,
                                                width: "150px",
                                            }}
                                        />
                                    );
                                })}
                            </Box>

                        </Box>

                    </Box>

                </Box>

                <Box display="flex" flexDirection="row" gap={2} mt={2} mb={0.1}>
                    {gameDetail?._id && <Button
                        fullWidth
                        variant="contained"
                        sx={{ height: 50, backgroundColor: "red", color: 'white', fontSize: 16 }}
                        onClick={() => {

                        }}
                     disabled={true}
                    >
                        {"Delete Game"}
                    </Button>}
                    <Button
                        fullWidth
                        variant="contained"
                        sx={{ height: 50, backgroundColor: "#a855f7", color: 'white', fontSize: 16 }}
                        onClick={() => {
                            gameDetail?._id ? editGame() : createGame();
                        }}
                    // disabled={!isValidNew}
                    >
                        {gameDetail?._id ? "Update Game" : "Add Game"}
                    </Button>
                </Box>
            </Box>

            {(loader) && <Loader />}

            <MultimediaDialog
                open={openMultimediaDialog}
                onClose={() => setOpenMultimediaDialog(false)}
                selectedItem={videoDetails}
                onSelect={(selectedItem) => {
                    console.log("✅ Selected Multimedia:", selectedItem);
                    setVideoDetails(selectedItem);
                    //handleChange("videoDetails", selectedItem);
                    handleChange("tambolaVideoId", selectedItem?._id);
                }}
            />
        </>
    );
}

const styles = {
    containerStyleRow_sx: {
        backgroundColor: '#f4f1f9',
        justifyContent: 'flex-start',
        borderRadius: 1,
        border: '1px solid #000000',
        padding: 4,
        display: "flex",
        flex: 1,
        flexDirection: "column",
        gap: 2,
        m: 4,
        height: "100%",
        alignItems: "center",
    },
    containerStyleColumn_sx: {
        backgroundColor: '#f4f1f9',
        justifyContent: 'center',
        display: "flex",
        flex: 1,
        flexDirection: "column",
        gap: 2,
    },
    containerStyleRowWithoutBorderNoColor_sx: {
        //backgroundColor: '#f4f1f9',
        justifyContent: 'center',
        display: "flex",
        flex: 1,
        flexDirection: "row",
        gap: 2
    },
}

const mapStateToProps = (state) => {
    return {

    }
};

const mapDispatchToProps = {

};

export default connect(mapStateToProps, mapDispatchToProps)(RapHousiCreateGame)